export class OutputInfo {
  public customer: string = '';
  public position: string = '';
  public reference: string = '';
  public typeCode: string = '';
  public name: string = '';
  public notes: string = '';
}
